import GoogleReview from '../public/assets/images/google_reviews.png'
export default function GoogleImg() {
    return (
        <img className="description__google" src={GoogleReview} alt="google" />
    )
}
